export default {
    BUTTON_ADD: "Přidej i ty komentář",
    BUTTON_EXPAND: "Zobrazit reakce (+%count%)",
    BUTTON_HIDE_0: "Skrýt komentáře",
    BUTTON_HIDE_1: "Skrýt 1 komentář",
    BUTTON_HIDE_2: "Skrýt %count% komentáře",
    BUTTON_HIDE_3: "Skrýt %count% komentářů",
    BUTTON_SHOW_0: "Buď první a přidej komentář",
    BUTTON_SHOW_0_SHORT: "Přidej komentář",
    BUTTON_SHOW_1: "Zobrazit 1 komentář",
    BUTTON_SHOW_1_SHORT: "1 komentář",
    BUTTON_SHOW_2: "Zobrazit %count% komentáře",
    BUTTON_SHOW_2_SHORT: "%count% komentáře",
    BUTTON_SHOW_3: "Zobrazit %count% komentářů",
    BUTTON_SHOW_3_SHORT: "%count% komentářů",
    COMMENT_AUTHOR: "Autor článku",
    COMMENT_BLOCKED: "Komentář byl odstraněn kvůli nevhodnému obsahu a porušení",
    COMMENT_BLOCKED_LINK: "Komunitních pravidel Refresheru",
    COMMENT_EDITOR: "Redaktor",
    COMMENT_EXTEND: "Zobrazit celý komentář",
    FORM_PLACEHOLDER: "Vyjádři svůj názor i ty...",
    FORM_SUBMIT: "Odeslat",
    MODAL_BUTTON_BLOCK: "Zablokovat",
    MODAL_BUTTON_CANCEL: "Zrušit",
    MODAL_BUTTON_DELETE: "Odstranit",
    MODAL_BUTTON_LOGIN: "Přihlásit se",
    MODAL_BUTTON_OK: "OK",
    MODAL_BUTTON_PREMIUM: "Předplatit",
    MODAL_BUTTON_REPORT: "Nahlásit",
    MODAL_BUTTON_VERIFY: "Ověřit účet",
    MODAL_TEXT_BLOCK: "Opravdu chceš zablokovat tento komentář?",
    MODAL_TEXT_DELETE: "Opravdu chceš odstranit svůj komentář?",
    MODAL_TEXT_ERROR_1: "Nepodařilo se načíst data pro diskuzi. Zkus obnovit stránku.\n\n" +
        "V případě že problémy přetrvávají, kontaktuj prosím administrátora.",
    MODAL_TEXT_ERROR_2: "Při přidávání komentáře nastala chyba. Zkus se nově přihlásit a znovu " +
        "odeslat komentář.\n\nV případě že problémy přetrvávají, kontaktuj prosím administrátora.",
    MODAL_TEXT_ERROR_3: "Při hodnocení komentáře nastala chyba. Zkus se nově přihlásit a znovu " +
        "ohodnotit komentář.\n\nV případě že problémy přetrvávají, kontaktuj prosím administrátora.",
    MODAL_TEXT_ERROR_4: "Při nahlášení komentáře nastala chyba. Zkus obnovit stránku.\n\n" +
        "V případě že problémy přetrvávají, kontaktuj prosím administrátora.",
    MODAL_TEXT_ERROR_5: "Při odstraňování komentáře nastala chyba. Zkus se nově přihlásit a znovu " +
        "odstranit komentář.\n\nV případě že problémy přetrvávají, kontaktuj prosím administrátora.",
    MODAL_TEXT_ERROR_6: "Nepodařilo se zablokovat komentář. Zkus se nově přihlásit a znovu " +
        "zablokovat komentář.\n\nV případě že problémy přetrvávají, kontaktuj prosím administrátora.",
    MODAL_TEXT_LOGIN_1: "Musíš být přihlášený/á, abys mohl/a přidat komentář.",
    MODAL_TEXT_LOGIN_2: "Musíš být přihlášený/á, abys mohl/a ohodnotit komentář.",
    MODAL_TEXT_PREMIUM: "Abys mohl přidat komentář, musíš mít předplacené REFRESHER+.",
    MODAL_TEXT_REPORT_1: "Opravdu chceš nahlásit tento komentář?",
    MODAL_TEXT_REPORT_2: "Děkujeme, komentář byl nahlášen.",
    MODAL_TEXT_VERIFY: "Komentář, který si přidal, vidíš zatím jen ty. Pro zobrazení komentářů ostatním uživatelům je třeba ověřit tvůj účet.",
    REPLY_BUTTON: "Odpovědět",
    REPLY_PLACEHOLDER: "Reagovat...",
    REPLY_SUBMIT: "Odeslat",
    SORT_RATING: "od nejoblíbenějších",
    SORT_TIMESTAMP: "od nejnovějších",
    TOOLTIP_BLOCK: "Zablokovat komentář",
    TOOLTIP_DELETE: "Odstranit komentář",
    TOOLTIP_REPORT: "Nahlásit komentář",
    TOOLTIP_PREMIUM: "Předplatitel REFRESHER+",
    UNVERIFIED_TITLE: "Komentář přidán od neověřeného uživatelského účtu.",
    UNVERIFIED_TEXT_1: "Po",
    UNVERIFIED_TEXT_2: "ověření",
    UNVERIFIED_TEXT_3: "ze strany uživatele se komentář zobrazí.",
};